import actionTypes from './actionTypes';
import { action, generateErrorAction } from '../actions';
import API from '../../apis';

export const getSalesReport = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());

      return API.salesReport
        .getSalesReport(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_SALES_REPORT_FAILED,
              reject: actionTypes.GET_SALES_REPORT_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.GET_SALES_REPORT_LOADING);
  const success = res => action(actionTypes.GET_SALES_REPORT_SUCCESS, res);

  return request();
};